
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/return-and-refund-policy",
      function () {
        return require("private-next-pages/return-and-refund-policy/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/return-and-refund-policy"])
      });
    }
  